import React, { Component } from "react";
import Card from "../../components/DashboardCard";
import PageHeader from "../../components/PageHeader";
import Confirmation from "../../components/Confirmation";
import ReviewText from "../../components/ReviewText";
import QuestionDescription from "../../components/QuestionDescription";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";
import { sanitiseHtml } from "../../utils/sanitiseHtml";
import { isFieldQuestionVisible } from "../../shared/informationRequest/fieldVisibility";
import { formItems } from "../../shared/informationRequest/informationRequestConfiguration";
import CompletedAnswers, { completedResponses } from "./dynamicForm/CompletedAnswers";

class DynamicFormSubmission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responses: {},
    };
  }

  componentDidMount() {
    this.setState({ responses: completedResponses(this.props.doable) });
  }

  createContent(content) {
    return { __html: sanitiseHtml(content) };
  }

  fields = () => this.props.doable.configuration?.fields ?? [];

  // A step can ask for documents alone, and a hidden question renders nothing.
  // Nothing is in bold then, so the line that points at the bold answers would
  // be pointing at nothing, and the client sent documents rather than answers.
  asksAQuestion = () =>
    this.fields().some(
      (item) =>
        item.field_type !== "document_upload" &&
        isFieldQuestionVisible(this.props.doable.configuration, item, this.state.responses),
    );

  renderResponses = () => {
    const { itemIdentifiers } = formItems(this.props.doable.configuration);
    if (!this.props.doable.submission || itemIdentifiers.length === 0) {
      return <p>We’ll be in touch if we have any questions.</p>;
    }

    return (
      <>
        <ReviewText>
          {this.asksAQuestion() ? "We’ve highlighted your responses in bold below" : "Here are the files you sent us"}
        </ReviewText>
        <CompletedAnswers doable={this.props.doable} responses={this.state.responses} />
      </>
    );
  };

  render() {
    if (!this.props.doable) return null;

    const requestTitle = this.props.doable.title;
    const requestDescription = this.props.doable.description;

    return (
      <React.Fragment>
        <ScrollToTop />
        <PageHeader>Things you’ve done</PageHeader>
        <Confirmation
          title={
            this.fields().length > 0 && !this.asksAQuestion()
              ? "We’ve got your documents"
              : "Thanks for filling in our form - we’ve got your answers"
          }
          submission={true}
        />

        <Card title={requestTitle} removeTopPadding>
          {requestDescription && (
            <QuestionDescription dangerouslySetInnerHTML={this.createContent(requestDescription)} />
          )}
          {this.renderResponses()}
        </Card>
        <Image src={imageOfficeWorking} fullWidth={true} />
      </React.Fragment>
    );
  }
}

export default DynamicFormSubmission;
